import { render } from "./AddActiviteModal.vue?vue&type=template&id=9f8be0ac&ts=true"
import script from "./AddActiviteModal.vue?vue&type=script&lang=ts"
export * from "./AddActiviteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__